import { WithEnterpriseId } from '@mews-commander/types';
import { Stack } from '@optimus-web/core';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { PropertyInfo } from './PropertyInfo';
import { PropertyTimeline } from './PropertyTimeline';
import { HelpSupport } from './HelpSupport';

export const LeftPanel = ({ enterpriseId }: WithEnterpriseId) => {
    const onboardingAuditNewLeftPanelEnabled = useFeatureFlag(FeatureFlag.onboardingAuditNewLeftPanelEnabled);

    return (
        <Stack spacing="200" vertical>
            {onboardingAuditNewLeftPanelEnabled ? <PropertyTimeline enterpriseId={enterpriseId} /> : null}
            <PropertyInfo enterpriseId={enterpriseId} />
            {onboardingAuditNewLeftPanelEnabled ? <HelpSupport /> : null}
        </Stack>
    );
};
